import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { PortalPermissions, defaultPerms } from '../../Common/CommonModels/PortalPermissions';

export function useGetPermissions() {
  const [myPermissions, setMyPermissions] = useState<PortalPermissions>(defaultPerms);
  const [isPermissionsLoading, setIsPermissionsLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    httpClient
      .get<PortalPermissions>(`${__API_BASE_URL__}/common/getPermissions`, {
        resource: __CLIENT_ID__,
        headers: {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        },
      })
      .then(({ data }) => {
        setMyPermissions({ 
            isAdmin: data.isAdmin, 
            isDataOwnerReviewer: data.isDataOwnerReviewer, 
            isPrivacyReviewer: data.isPrivacyReviewer,
            isAuditor: data.isAuditor 
          });
        setIsPermissionsLoading(false);
      })
      .catch(() => {
        setMyPermissions(defaultPerms);
        setIsPermissionsLoading(false);
      });
  }, []);

  return [myPermissions, isPermissionsLoading] as const;
}
